import { HttpClient } from '@angular/common/http';
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { Observable } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ForgetPasswordService {
  private isBrowser: boolean;

  constructor(
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  forgetPassword(email: string): Observable<any> {
    return this.http.post(environment.Server_URL + '/password/forgot', {
      email,
    });
  }

  newPassword(
    email: string,
    verification_code: string,
    password: string,
    confirm_password: string
  ): Observable<any> {
    return this.http.post(environment.Server_URL + '/new-password', {
      email,
      verification_code,
      password,
      confirm_password,
    });
  }

  setToken(token: string): void {
    if (this.isBrowser) {
      localStorage.setItem('token', token);
    }
  }

  getToken(): string | null {
    if (this.isBrowser) {
      return localStorage.getItem('token');
    }
    return null;
  }
}
